import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AccessibilityStateService {
  readonly open = signal(false);

  toggle(): void { this.open.update(value => !value); }
}
